export type RecordStepState = 'ready' | 'recording' | 'succeeded'
export type HelperAudioAction = 'play_piano' | 'play_example'
export type RecordFlowErrorKey =
  | 'permission'
  | 'start'
  | 'stop'
  | 'playback'
  | null

export interface RecordUiState {
  step: RecordStepState
  isHelperActionPending: boolean
  failedHelperAction: HelperAudioAction | null
  recordFlowErrorKey: RecordFlowErrorKey
  recordedAudioUri: string | null
  confirmedRecordingUri: string | null
  isStartingRecording: boolean
  isStoppingRecording: boolean
  isListeningPending: boolean
}

export type RecordUiAction =
  | { type: 'setStep'; payload: RecordStepState }
  | { type: 'setHelperActionPending'; payload: boolean }
  | { type: 'setFailedHelperAction'; payload: HelperAudioAction | null }
  | { type: 'setRecordFlowErrorKey'; payload: RecordFlowErrorKey }
  | { type: 'setRecordedAudioUri'; payload: string | null }
  | { type: 'setConfirmedRecordingUri'; payload: string | null }
  | { type: 'setStartingRecording'; payload: boolean }
  | { type: 'setStoppingRecording'; payload: boolean }
  | { type: 'setListeningPending'; payload: boolean }

export const INITIAL_RECORD_UI_STATE: RecordUiState = {
  step: 'ready',
  isHelperActionPending: false,
  failedHelperAction: null,
  recordFlowErrorKey: null,
  recordedAudioUri: null,
  confirmedRecordingUri: null,
  isStartingRecording: false,
  isStoppingRecording: false,
  isListeningPending: false,
}

export function recordUiReducer(
  state: RecordUiState,
  action: RecordUiAction,
): RecordUiState {
  switch (action.type) {
    case 'setStep':
      return { ...state, step: action.payload }
    case 'setHelperActionPending':
      return { ...state, isHelperActionPending: action.payload }
    case 'setFailedHelperAction':
      return { ...state, failedHelperAction: action.payload }
    case 'setRecordFlowErrorKey':
      return { ...state, recordFlowErrorKey: action.payload }
    case 'setRecordedAudioUri':
      return { ...state, recordedAudioUri: action.payload }
    case 'setConfirmedRecordingUri':
      return { ...state, confirmedRecordingUri: action.payload }
    case 'setStartingRecording':
      return { ...state, isStartingRecording: action.payload }
    case 'setStoppingRecording':
      return { ...state, isStoppingRecording: action.payload }
    case 'setListeningPending':
      return { ...state, isListeningPending: action.payload }
    default:
      return state
  }
}
